import { RatingDistributionBar } from 'components/PageWrappers/AdDetails/components/RatingDistributionBar/RatingDistributionBar';
import type { RatingsDistributionProps } from 'components/Ratings/RatingsDistribution/RatingsDistribution.typed';

const RatingsDistribution = (props: RatingsDistributionProps) => {
  const { userRating } = props;
  const { reviewCount = 0 } = userRating || {};

  const ratingDistributionKeyMap = [
    'fiveStars',
    'fourStars',
    'threeStars',
    'twoStars',
    'oneStar',
  ] as const;

  return (
    <>
      {ratingDistributionKeyMap.map((key, index) => {
        const distribution = userRating?.ratingStarDistribution[key] ?? 0;

        return (
          <RatingDistributionBar
            key={key}
            dataTestId={`rating-distribution-${index}`}
            starNumber={5 - index}
            ratingCount={distribution}
            totalRatings={reviewCount ?? 0}
          />
        );
      })}
    </>
  );
};

export { RatingsDistribution };
